export default __webpack_public_path__ + "b27fc63bb3860d46c38c22c082820731.svg";